import { gql } from "@apollo/client";

export const approvalCompanyPolicyNudges = gql`
  mutation approvalCompanyPolicyNudges($companyPolicyId: MongoID!, $approvedIds: [MongoID!]!) {
    CompanyPolicyNudge_Approval(companyPolicyId: $companyPolicyId, approvedIds: $approvedIds) {
      _id
      title
      description
      status
      ai_generated
      created_by_user {
        _id
        name
      }
      created_at
      updated_by_user {
        _id
        name
      }
      updated_at
    }
  }
`;
